import { Link } from "@mui/material";

const TelLink = ({ children, tel, ...rest }) => {
  let cleanedTel = tel?.trim().replaceAll(/((?<!^)[^0-9]|^[^0-9+])/g, "");

  return (
    <Link href={`tel:${cleanedTel}`} underline="none" {...rest}>
      {children || tel}
    </Link>
  );
};

export default TelLink;
